/** Article-scoped ownership: these RO revisions use native route head only. */
export const REVIEWED_BLOG_SLUGS = [
  'suv-uri-second-hand-familii-2025',
  'cele-mai-fiabile-masini-second-hand-2025',
  'cele-mai-bune-suv-uri-second-hand-sub-10000-euro-romania',
  'bmw-audi-mercedes-comparatie',
  'probleme-comune-bmw',
  'bmw-diesel',
  'bmw-automat',
  'verificare-istoric-auto-gratis-2025',
] as const;

export const isReviewedBlogSlug = (slug: string) =>
  REVIEWED_BLOG_SLUGS.some(value => value === slug);

type ArticleHeadData = {
  slug: string; title: string; seoTitle?: string | null; excerpt: string;
  date: string; dateModified?: string | null; author: string; category: string;
  image?: string | null; ogImage?: string | null;
};

export function reviewedBlogHead(post: ArticleHeadData) {
  const url = `https://roautomarket.ro/blog/${post.slug}`;
  const title = post.seoTitle || `${post.title} | RO Auto Market`;
  const image = post.ogImage || (post.image
    ? post.image.startsWith('https://') ? post.image : `https://roautomarket.ro${post.image}`
    : null);
  return {
    meta: [
      { title },
      { name: 'description', content: post.excerpt },
      { property: 'og:title', content: title },
      { property: 'og:description', content: post.excerpt },
      { property: 'og:type', content: 'article' },
      { property: 'og:url', content: url },
      { property: 'og:locale', content: 'ro_RO' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: post.excerpt },
      { property: 'article:published_time', content: post.date },
      ...(post.dateModified ? [{ property: 'article:modified_time', content: post.dateModified }] : []),
      ...(image ? [{ property: 'og:image', content: image }, { name: 'twitter:image', content: image }] : []),
    ],
    links: [{ rel: 'canonical', href: url }],
    scripts: [{
      type: 'application/ld+json',
      children: JSON.stringify({
        '@context': 'https://schema.org', '@type': 'Article',
        headline: post.title, description: post.excerpt,
        datePublished: post.date,
        ...(post.dateModified ? { dateModified: post.dateModified } : {}),
        ...(image ? { image } : {}),
        articleSection: post.category,
        author: { '@type': 'Person', name: post.author, url: 'https://roautomarket.ro/despre-noi' },
        publisher: { '@type': 'Organization', name: 'RO Auto Market' },
        mainEntityOfPage: { '@type': 'WebPage', '@id': url },
      }),
    }],
  };
}